export interface PurchaseInvoiceHeaderExtraItem {
  id: string;
  purchaseInvoiceHeaderId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  notes: string;
  extraValue: number;
}
